import { useEffect, Dispatch, SetStateAction } from 'react';
import { useSelector } from 'react-redux';
import { AxiosError } from 'axios';
import { SetIsError, SetErrorMessage, SetLoginForm, AuthInfo, SetErrorCode } from '@app/models';
import { parseString } from '@app/helpers';
import { loginForms } from '@app/enums';

export const useErrorLoginObserver = (
    setIsError: SetIsError,
    setErrorMessage: SetErrorMessage,
    setLoginForm: SetLoginForm,
    setAuthInfo: Dispatch<SetStateAction<AuthInfo>>,
    setErrorCode: SetErrorCode
) => {
    const error: AxiosError<any> = useSelector((state: any) => state.signIn.error);
    const errorDescription = error?.response?.data?.error_description ?? '';
    const errorCode = error?.response?.data?.error ?? '';
    const errorUri = error?.response?.data?.error_uri ?? '';

    useEffect(() => {
        if (errorDescription === 'verification_options') {
            const { providers, context } = parseString(window.atob(errorUri));

            setAuthInfo((info) => ({
                ...info,
                providers,
                contextToken: context
            }));

            setLoginForm(loginForms.twoFactorList);
        } else if (error && error.response) {
            setIsError(true);
            setErrorMessage && setErrorMessage(errorDescription);
            setErrorCode(errorCode);
        }
    }, [error]);
};
